import { queryOptions } from "@tanstack/react-query"

import { getIsomorphicSupabaseClient } from "@repo/supabase/isomorphic-client"
import { createRolesAndPermissionsService } from "./roles-and-permissions.service"

export const getCurrentUserRolePermissionsQueryOptions = (userId: string) =>
  queryOptions({
    queryKey: ["current-user-role-permissions", userId],
    queryFn: async () => {
      const supabase = await getIsomorphicSupabaseClient()
      const rolesAndPermissionsService =
        createRolesAndPermissionsService(supabase)
      return rolesAndPermissionsService.getCurrentUserRolePermissions()
    },
    retryOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchInterval: 1000 * 60 * 5, // 5 minutes
    refetchIntervalInBackground: true,
    staleTime: 1000 * 60 * 4, // 4 minutes
    enabled: !!userId,
  })

export const getAssignableRolesForUnitQueryOptions = (unitId: string) =>
  queryOptions({
    queryKey: ["assignable-roles-for-unit", unitId],
    queryFn: async () => {
      const supabase = await getIsomorphicSupabaseClient()
      const rolesAndPermissionsService =
        createRolesAndPermissionsService(supabase)
      return rolesAndPermissionsService.getAssignableRolesForUnit({ unitId })
    },
    retryOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!unitId,
  })
